/**
 * Min/max/avg over a list of numbers, skipping non-finite entries (null/undefined/NaN) so they
 * don't skew the result. e.g. gen2 poses carry a null binding score; counting them as 0 would
 * corrupt the summary in a mixed set. The average is over the finite count, not the list length.
 * Returns null stats and an "N/A" summary when nothing finite is present.
 * @param {Array<number|null|undefined>} values
 * @returns {{ min: number|null, max: number|null, avg: number|null, summary: string }}
 */
export function finiteStats(values) {
    const stats = {
        min: null, max: null, avg: null, summary: null,
    };
    let total = 0;
    let count = 0;
    for (const value of values) {
        if (!Number.isFinite(value)) continue;
        if (stats.min == null || value < stats.min) stats.min = value;
        if (stats.max == null || value > stats.max) stats.max = value;
        total += value;
        count += 1;
    }
    stats.avg = count > 0 ? total / count : null;
    stats.summary = `Min: ${stats.min?.toFixed(1) || 'N/A'}; Max: ${stats.max?.toFixed(1) || 'N/A'}; Avg: ${stats.avg?.toFixed(1) || 'N/A'}`;
    return stats;
}
